<template>
  <v-container id="dashboard" tag="section" class="my-3 pb-15" fluid>
    <v-row dense>
      <v-col v-for="(info, i) in cardsInformativos" :key="i" cols="12" sm="6" md="3">
        <informativo-generico :icon="info.icon" :heading="info.heading" :value="info.value" style="max-height: 100% !important" />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="4">
        <v-card class="ma-0 pa-0" height="100%">
          <br />
          <div class="caption font-weight-light ml-2 mt-n2">ATIVO EM CURSO</div>
          <saldo-aic-line class="mt-3" />
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="ma-0 pa-0" height="100%">
          <br />
          <div class="caption font-weight-light ml-2 mt-n2">
            IMOBILIZADO INCREMENTAL {{ ['light', 'light-e'].includes(empresa) ? '' : '(LTM)' }}
          </div>
          <imobilizado-acumulado-line class="mt-3" />
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="ma-0 pa-0" height="100%">
          <br />
          <div class="caption font-weight-light ml-2 mt-n2">IMOBILIZADO ÚLTIMO MÊS - {{ ultimoAIS }}</div>
          <imobilizado-ultimo-mes-tipologia-pie ref="imobpie" />
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12" md="4">
        <v-card class="ma-0 pa-0" height="100%">
          <br />
          <div class="caption font-weight-light ml-2 mt-n2">Aderência: BDGD vs. AIS - {{ ultimoBdgd }}</div>
          <diferenca-ais-geo-negative-bar ref="comparativoNegativeBar" />
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="ma-0 pa-0" height="100%">
          <br />
          <div class="caption font-weight-light ml-2 mt-n2">ÁREA DE CONCESSÃO</div>
          <v-row>
            <v-col cols="12">
              <mapa-area-atuacao />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" md="4">
        <v-card class="ma-0 pa-0" height="100%">
          <br />
          <div class="caption font-weight-light ml-2 mt-n2">DADOS DA CONCESSÃO</div>
          <dados-concessao style="max-height: 250px" />
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col v-if="isEnel" cols="12" md="4">
        <v-card class="ma-0 pa-0" height="100%">
          <br />
          <div class="caption font-weight-light ml-2 mt-n2">ACOMPANHAMENTO DO CAPEX (PMSO E OPEX)</div>
          <v-row>
            <v-col cols="12">
              <acompanhamento-do-capex />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-row dense>
      <v-col v-if="isCopel" cols="12" md="4">
        <v-card class="ma-0 pa-0" height="100%">
          <br />
          <div class="caption font-weight-light ml-2 mt-n2">Resumo das Bases</div>
          <v-row>
            <v-col cols="12">
              <resumo-das-bases />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <div id="tawk-to-fab" class="location-fab-tawk" />
  </v-container>
</template>

<script>
  import Firestore from '@/Firestore.js';
  import dayjs from 'dayjs';
  import 'dayjs/locale/pt';
  import tourMixins from '@/mixins/tourMixins';
  import drawerMixins from '@/mixins/drawerMixins';

  export default {
    name: 'Home',
    components: {
      MapaAreaAtuacao: () => import('@/components/general/graficos/MapaAreaAtuacao/MapaAreaAtuacao.vue'),
      DadosConcessao: () => import('@/components/general/graficos/MapaAreaAtuacao/DadosConcessao.vue'),
      SaldoAicLine: () => import('@/components/general/graficos/SaldoAicLine.vue'),
      ImobilizadoAcumuladoLine: () => import('@/components/general/graficos/ImobilizadoAcumuladoLine.vue'),
      ImobilizadoUltimoMesTipologiaPie: () => import('@/components/general/graficos/ImobilizadoUltimoMesTipologiaPie.vue'),
      DiferencaAisGeoNegativeBar: () => import('@/components/general/graficos/DiferencaAisGeoNegativeBar.vue'),
      InformativoGenerico: () => import('@/components/general/graficos/informativo/InformativoGenerico.vue'),
      AcompanhamentoDoCapex: () => import('@/components/general/graficos/AcompanhamentoDoCapex.vue'),
      ResumoDasBases: () => import('@/components/general/graficos/ResumoDasBases.vue')
    },
    mixins: [drawerMixins, tourMixins],
    data() {
      return {
        baseLiquida: [],
        receitaAtivos: [],
        depreciacaoAnual: [],
        investimentoIncremental: [],
        dataUltimoBdgd: [],
        dataUltimoAis: []
      };
    },
    firestore() {
      return {
        dataUltimoBdgd: Firestore.collection(`consultas_dashboard_${this.empresa}`).doc('Firebase - Ultimo BDGD'),
        dataUltimoAis: Firestore.collection(`consultas_dashboard_${this.empresa}`).doc('Firebase - Ultimo AIS'),
        baseLiquida: Firestore.collection(`consultas_dashboard_${this.empresa}`).doc('Firebase - Base Líquida Última Rev'),
        receitaAtivos: Firestore.collection(`consultas_dashboard_${this.empresa}`).doc('Firebase - Receita Ativos'),
        depreciacaoAnual: Firestore.collection(`consultas_dashboard_${this.empresa}`).doc('Firebase - Depreciação Anual'),
        investimentoIncremental: Firestore.collection(`consultas_dashboard_${this.empresa}`).doc('Firebase - Imobilizado LTM')
      };
    },
    computed: {
      empresa() {
        return this.$store.getters.getEmpresa.toLowerCase();
      },
      isEnel() {
        const sigla = this.$store.getters.getSiglaEmpresa.toUpperCase();
        return ['EDC', 'EDR', 'EDS'].includes(sigla);
      },
      ultimoBdgd: function () {
        if (this.dataUltimoBdgd == null || this.dataUltimoBdgd.length == 0) return '';
        return dayjs(this.dataUltimoBdgd['0']['MaxDataBaseBDGD']).locale('pt').format('MM/YYYY');
      },
      ultimoAIS: function () {
        if (this.dataUltimoAis == null || this.dataUltimoAis.length == 0) return '';
        return dayjs(this.dataUltimoAis['0']['MaxDataBaseAIS']).locale('pt').format('MM/YYYY');
      },
      valorDepreciacaoAnual: function () {
        if (this.depreciacaoAnual == null || this.depreciacaoAnual.length == 0) return 0;
        let result = this.depreciacaoAnual[0].VALOR;
        return result.toLocaleString('pt-br', { maximumFractionDigits: 2 });
      },
      valorInvestimentoIncremental: function () {
        var value = 0;
        if (this.investimentoIncremental == null || this.investimentoIncremental.length == 0) return 0;

        var aux = Object.values(this.investimentoIncremental);
        aux.forEach(function (element) {
          value = element.VOC_ACUMULADO;
        });
        return value;
      },
      valorReceitaAtivos: function () {
        if (this.receitaAtivos == null || this.receitaAtivos.length == 0) return 0;
        return this.receitaAtivos[0].VALOR;
      },
      valorBaseLiquida: function () {
        if (this.baseLiquida == null || this.baseLiquida.length == 0) return 0;
        return this.baseLiquida[0].VALOR;
      },
      cardsInformativos: function () {
        return [
          { icon: 'mdi-gold', heading: 'BASE LÍQUIDA (ÚLTIMA REV.)', value: 'R$ ' + this.treatNumber(this.valorBaseLiquida) },
          {
            icon: 'mdi-currency-usd',
            heading: 'CAA (CUSTO ANUAL DOS ATIVOS)',
            value: 'R$ ' + this.treatNumber(this.valorReceitaAtivos) + '/ano'
          },
          { icon: 'mdi-stairs-up mdi-rotate-90', heading: 'DEPRECIAÇÃO ANUAL', value: this.valorDepreciacaoAnual + '%' },
          {
            icon: 'mdi-chart-areaspline',
            heading: 'INVESTIMENTO INCREMENTAL',
            value: 'R$ ' + this.treatNumber(this.valorInvestimentoIncremental)
          }
        ];
      },
      isCopel() {
        const sigla = this.$store.getters.getSiglaEmpresa.toUpperCase();
        return ['COPEL'].includes(sigla);
      }
    },
    mounted() {
      if (this.empresa) {
        const arrTour = [
          {
            title: 'Bem vindo ao HEXA',
            intro: `O seu sistema exclusivo de Gestão Estratégica de BRR.<br<br><br><br>
                    Este breve tutorial apresenta instruções básicas para navegação no sistema.<br><br>
                    Para desabilitá-lo basta fechar esta caixa de mensagem.<br> Caso queira acessar o tutorial posteriormente, clique no botão <b>(?)</b> no menu lateral.
                    `
          },
          {
            element: '#core-navigation-drawer',
            title: 'Menu',
            intro: 'Este é o menu principal, nele estão as principais funcionalidades do <b>HEXA</b>.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#drawer-section-profile',
            title: 'Perfil',
            intro: 'Aqui você poderá editar seus dados pessoais (foto, nome e senha) e deslogar do sistema.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#drawer-section-mudar-empresa',
            title: 'Mudar de empresa',
            intro: 'Aqui você poderá se conectar ao sistema de outras empresas que você tem acesso.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#drawer-section-dashboard',
            title: 'Dashboard',
            intro:
              'Esta é a tela inicial do <b>HEXA</b>, onde são apresentados os gráficos e principais informações de BRR da distribuidora.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#drawer-section-relatórios',
            title: 'Relatórios',
            intro:
              'Aqui você poderá fazer consultas sobre as bases de dados ou usar relatórios modelo (predefinidos). Também é possível acessar tabelas regulatórias (MCPSE, índices de inflação, módulos BPR, etc).',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#drawer-section-powerups',
            title: 'Power Ups',
            intro:
              'Aqui você acessa as ferramentas exclusivas de Gestão de BRR, Conformidade de Obras, Fiscalização da ANEEL, dentre outras.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#drawer-section-dados',
            title: 'Dados',
            intro: 'Aqui você poderá atualizar os dados do sistema através de arquivos CSV, cadastro de IPCA, dentre outros.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#drawer-section-tutorial',
            title: 'Tutorial',
            intro: 'Clicando nessa opção você poderá acessar o tutorial sempre que precisar.',
            scrollTo: 'tooltip',
            position: 'right'
          },
          {
            element: '#tawk-to-fab',
            title: 'Chat',
            intro: 'Em caso de dúvidas, entre em contato com um dos nossos especialistas em tempo real através do nosso chat.',
            scrollTo: 'tooltip',
            position: 'top'
          }
        ];
        this.iniciarTour(arrTour);
        this.changeSizeHeaderDashBoard();
      }
    },
    methods: {
      treatNumber(number) {
        const MILLION = 1000000;
        const BILLION = 1000000000;
        const TRILLION = 1000000000000;
        const isMillion = number / MILLION;
        const isBillion = number / BILLION;
        const isTrillion = number / TRILLION;
        const maximumFractionDigits = 2;
        if (number >= TRILLION) {
          return isTrillion.toLocaleString('pt-br', { maximumFractionDigits }) + ' ' + (isTrillion < 2 ? 'Trilhão' : 'Trilhões');
        } else if (number >= BILLION) {
          return isBillion.toLocaleString('pt-br', { maximumFractionDigits }) + ' ' + (isBillion < 2 ? 'Bilhão' : 'Bilhões');
        }
        return isMillion.toLocaleString('pt-br', { maximumFractionDigits }) + ' ' + (isMillion < 2 ? 'Milhão' : 'Milhões');
      },
      initTour() {
        let elementBody = document.getElementsByTagName('html')[0];

        let onBeforeChangeFunction = () => {
          /* ira fixar a tela simulando scroll desabilitado */
          elementBody.style.position = 'fixed';
          elementBody.style.top = '0';
          elementBody.style.width = '100%';
        };

        let onBeforeExitFunction = () => {
          /* ira retirar a fixação de tela retirando efeito da func onBeforeChange */
          elementBody.style.position = '';
          elementBody.style.top = '';
        };

        this.iniciarTour(this.arrTerceiraTabTour, [], [onBeforeChangeFunction], [onBeforeExitFunction]);
      }
    },
    watch: {
      '$vuetify.breakpoint.width'() {
        this.changeSizeHeaderDashBoard();
      }
    }
  };
</script>

<style scoped>
  .location-fab-tawk {
    position: fixed;
    bottom: 1.4rem;
    right: 19px;
    width: 61px;
    border-radius: 50%;
    padding: 30px;
  }
</style>
